import { initGoogleScript } from "~/lib/google.js"
import "~/controllers/index.js"
import "@hotwired/turbo-rails"

window.initGoogleScript = initGoogleScript;
